import React from "react";
import { FIELD_CONTROL, FIELD_HINT, FIELD_LABEL, readNumberField } from "../ui";
import { FIELDS, NumberFieldName, Programme } from "./calculator";

const INTEGER_FIELDS: ReadonlySet<NumberFieldName> = new Set<NumberFieldName>([
  "participants",
  "openRoles",
  "newHires",
]);

type Props = {
  name: NumberFieldName;
  programme: Programme;
  onChange: (name: NumberFieldName, value: number) => void;
};

export default function NumberField({ name, programme, onChange }: Props) {
  const field = FIELDS[name];
  const id = `roi-${name}`;
  const hintId = `${id}-hint`;

  return (
    <div className="tw-min-w-0">
      <label htmlFor={id} className={FIELD_LABEL}>
        {field.label}
      </label>
      <input
        id={id}
        name={name}
        type="number"
        required
        inputMode={INTEGER_FIELDS.has(name) ? "numeric" : "decimal"}
        min={field.min}
        max={field.max}
        step={field.step}
        value={Number.isFinite(programme[name]) ? programme[name] : ""}
        aria-describedby={hintId}
        onChange={(event) => onChange(name, readNumberField(event))}
        className={FIELD_CONTROL}
      />
      <p id={hintId} className={FIELD_HINT}>
        {field.hint}
      </p>
    </div>
  );
}
